// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__18-kT","description":"MealItem_description__DK1L3","price":"MealItem_price__8VQF6"};